



































import InputField from "./InputField.vue";

export default {
    name: "SignaturePad",
    components: { InputField },
    props: {
        label: String,
        value: String,
        height: {
            type: Number,
            default: 120,
        },
    },
    data() {
        return {
            drawing: false,
            lastPoint: null,
            hasDrawn: false,
            canvasStyle: {
                "touch-action": "none",
                "-ms-touch-action": "none",
            },
        };
    },
    mounted() {
        this.resizeCanvas();
        window.addEventListener("resize", this.resizeCanvas);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resizeCanvas);
    },
    methods: {
        /**
         * (Re)dimensionne le canvas à la largeur de son parent et réapplique le
         * style de tracé. Le contenu déjà dessiné est restauré : redimensionner
         * un canvas remet son contexte à zéro.
         */
        resizeCanvas: function () {
            let canvas = this.$refs.canvas;
            if (!canvas || !canvas.parentElement) {
                return;
            }

            let previous = null;
            if (this.hasDrawn && canvas.width > 0 && canvas.height > 0) {
                previous = canvas.toDataURL();
            }

            let rect = canvas.parentElement.getBoundingClientRect();
            canvas.width = rect.width;
            canvas.height = this.height;

            let ctx = canvas.getContext("2d");
            ctx.lineWidth = 2;
            ctx.lineCap = "round";
            ctx.strokeStyle = "#1a1d23";

            if (previous) {
                let img = new Image();
                img.onload = function () {
                    ctx.drawImage(img, 0, 0);
                };
                img.src = previous;
            }
        },
        /** Efface la signature et émet `input` avec `null`. */
        clear: function () {
            let canvas = this.$refs.canvas;
            if (canvas) {
                let ctx = canvas.getContext("2d");
                ctx.clearRect(0, 0, canvas.width, canvas.height);
            }
            this.hasDrawn = false;
            this.$emit("input", null);
        },
        /** Vrai tant qu'aucun trait n'a été tracé. */
        isEmpty: function (): boolean {
            return !this.hasDrawn;
        },
        /** Data-URL PNG de la signature, ou `null` si vide. */
        getData: function (): string | null {
            if (!this.hasDrawn || !this.$refs.canvas) {
                return null;
            }
            return this.$refs.canvas.toDataURL();
        },
        getPoint: function (event) {
            let canvas = this.$refs.canvas;
            let rect = canvas.getBoundingClientRect();
            let t =
                event.touches && event.touches.length
                    ? event.touches[0]
                    : event;
            return { x: t.clientX - rect.left, y: t.clientY - rect.top };
        },
        start: function (event) {
            event.preventDefault();
            this.drawing = true;
            this.lastPoint = this.getPoint(event);
        },
        move: function (event) {
            if (!this.drawing) {
                return;
            }
            event.preventDefault();
            let canvas = this.$refs.canvas;
            let ctx = canvas.getContext("2d");
            let point = this.getPoint(event);
            ctx.beginPath();
            ctx.moveTo(this.lastPoint.x, this.lastPoint.y);
            ctx.lineTo(point.x, point.y);
            ctx.stroke();
            this.lastPoint = point;
            this.hasDrawn = true;
        },
        end: function () {
            if (!this.drawing) {
                return;
            }
            this.drawing = false;
            this.$emit("input", this.getData());
        },
    },
};
